import { router } from '@app/router';
import {
  browserTracingIntegration,
  init,
  replayIntegration,
  tanstackRouterBrowserTracingIntegration,
} from '@sentry/react';
import { queryClient } from '@src/lib/react-query';
import { silenceAuthErrors } from '@src/utils/sentry-utility';
import { RouterProvider } from '@tanstack/react-router';

init({
  beforeSend: silenceAuthErrors,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_NODE_ENV,
  tunnel: import.meta.env.VITE_SENTRY_TUNNEL,
  integrations: [
    browserTracingIntegration(),
    // Explicitly pin masking so financial-form inputs (SSN, account numbers in
    // common-application) are never captured in Session Replay. These match
    // the Sentry SDK defaults today, but pinning them means a future SDK
    // default change or accidental edit can't silently start recording PII.
    replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
    tanstackRouterBrowserTracingIntegration(router),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    window.location.origin,
    import.meta.env.VITE_BASE_URL,
  ],
  release: import.meta.env.VITE_APP_VERSION,
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const AppRouter = () => {
  return (
    <RouterProvider
      router={router}
      context={{
        queryClient,
      }}
    />
  );
};
export default AppRouter;
